import React, { Component } from "react";
import CssClasses from "./FindTicket.css";

import { SelectTicket } from "../../../Communication/TicketServicesHandler";
import "react-datepicker/dist/react-datepicker-cssmodules.css";

import { connect } from "react-redux";
import * as StoreActions from "../../../ReduxStore/Actions/ActionIndex";

class FindTicket extends Component {
  state = {
    ticketNumber: "",
    currentTicket: {}
  };

  currentTicket = {};

  render() {
    return (
      <div className={CssClasses.container}>
        <div className={CssClasses.row}>&nbsp;</div>
        <div className={CssClasses.row}>
          <div className={CssClasses.colLeft}>Broj tiketa:</div>
          <div className={CssClasses.colRight}>
            <input
              type="text"
              className={CssClasses.txtTicketNo}
              value={this.state.ticketNumber}
              onChange={this.txtTicketNumber_Change.bind(this)}
            />
          </div>
        </div>
        <div className={CssClasses.separator}>&nbsp;</div>
        <div className={CssClasses.row}>
          <div className={CssClasses.colLeft}>&nbsp;</div>
          <div className={CssClasses.colRight}>
            <button
              className={[CssClasses.loadDataBtn, CssClasses.noLeftMargin].join(
                " "
              )}
              onClick={() => this.btnLoadData_Click()}
            >
              Pronađi
            </button>
          </div>
        </div>
        <div className={CssClasses.separator}>&nbsp;</div>
        <div className={CssClasses.tableContainer}>
          <div className={CssClasses.colTicketStats}>
            <div className={CssClasses.rowLegend}>Broj listića:</div>
            <div className={CssClasses.rowData}>
              <input
                type="text"
                className={CssClasses.dataTextbox}
                value={this.state.currentTicket.TicketNumber || ""}
              />
            </div>

            <div className={CssClasses.rowLegend}>Vrijeme uplate:</div>
            <div className={CssClasses.rowData}>
              <input
                type="text"
                className={CssClasses.dataTextbox}
                value={this.state.currentTicket.TimestampAccepted || ""}
              />
            </div>

            <div className={CssClasses.rowLegend}>Vrsta listića:</div>
            <div className={CssClasses.rowData}>
              <input
                type="text"
                className={CssClasses.dataTextbox}
                value={this.state.currentTicket.TicketTypeFMT || ""}
              />
            </div>

            <div className={CssClasses.rowLegend}>Status listića:</div>
            <div className={CssClasses.rowData}>
              <input
                type="text"
                className={CssClasses.dataTextbox}
                value={this.state.currentTicket.StatusFMT || ""}
              />
            </div>

            <div className={CssClasses.rowLegend}>Broj parova:</div>
            <div className={CssClasses.rowData}>
              <input
                type="text"
                className={CssClasses.dataTextbox}
                value={this.state.currentTicket.NumberOfPairs || ""}
              />
            </div>

            <div className={CssClasses.rowLegend}>Koeficijent:</div>
            <div className={CssClasses.rowData}>
              <input
                type="text"
                className={CssClasses.dataTextbox}
                value={this.state.currentTicket.Odds || ""}
              />
            </div>

            <div className={CssClasses.rowLegend}>Je uranjeno isplaćen?</div>
            <div className={CssClasses.rowData}>
              <input
                type="text"
                className={CssClasses.dataTextbox}
                value={this.state.currentTicket.IsEarlyPayoutFMT || ""}
              />
            </div>
          </div>
          <div className={CssClasses.colTicketStats}>
            <div className={CssClasses.rowLegend}>Iznos uplate:</div>
            <div className={CssClasses.rowData}>
              <input
                type="text"
                className={CssClasses.dataTextbox}
                value={
                  this.state.currentTicket.TotalPayinAmount
                    ? this.state.currentTicket.TotalPayinAmount.toFixed(2)
                    : ""
                }
              />
            </div>

            <div className={CssClasses.rowLegend}>
              % manipulativnih troškova:
            </div>
            <div className={CssClasses.rowData}>
              <input
                type="text"
                className={CssClasses.dataTextbox}
                value={
                  this.state.currentTicket.TaxAmount
                    ? this.state.currentTicket.TaxAmount.toFixed(2)
                    : ""
                }
              />
            </div>

            <div className={CssClasses.rowLegend}>
              Iznos manipulativnih troškova:
            </div>
            <div className={CssClasses.rowData}>
              <input
                type="text"
                className={CssClasses.dataTextbox}
                value={
                  this.state.currentTicket.TotalPayinAmount
                    ? this.state.currentTicket.TotalPayinAmount.toFixed(2)
                    : ""
                }
              />
            </div>

            <div className={CssClasses.rowLegend}>Ulog:</div>
            <div className={CssClasses.rowData}>
              <input
                type="text"
                className={CssClasses.dataTextbox}
                value={
                  this.state.currentTicket.TotalBet
                    ? this.state.currentTicket.TotalBet.toFixed(2)
                    : ""
                }
              />
            </div>

            <div className={CssClasses.rowLegend}>Mogući dobitak:</div>
            <div className={CssClasses.rowData}>
              <input
                type="text"
                className={CssClasses.dataTextbox}
                value={
                  this.state.currentTicket.WinAmount
                    ? this.state.currentTicket.WinAmount.toFixed(2)
                    : ""
                }
              />
            </div>

            <div className={CssClasses.rowLegend}>Porez:</div>
            <div className={CssClasses.rowData}>
              <input
                type="text"
                className={CssClasses.dataTextbox}
                value={
                  this.state.currentTicket.TaxAmount
                    ? this.state.currentTicket.TaxAmount.toFixed(2)
                    : ""
                }
              />
            </div>

            <div className={CssClasses.rowLegend}>Moguća isplata:</div>
            <div className={CssClasses.rowData}>
              <input
                type="text"
                className={CssClasses.dataTextbox}
                value={
                  this.state.currentTicket.WinAmount
                    ? this.state.currentTicket.WinAmount.toFixed(2)
                    : ""
                }
              />
            </div>

            <div className={CssClasses.rowLegend}>Dosad isplaćeno:</div>
            <div className={CssClasses.rowData}>
              <input
                type="text"
                className={CssClasses.dataTextbox}
                value={
                  this.state.currentTicket.RealPayout
                    ? this.state.currentTicket.RealPayout.toFixed(2)
                    : ""
                }
              />
            </div>

            <div className={CssClasses.rowLegend}>Preostalo za isplatu:</div>
            <div className={CssClasses.rowData}>
              <input
                type="text"
                className={CssClasses.dataTextbox}
                value={
                  this.state.currentTicket.RemainingWin
                    ? this.state.currentTicket.RemainingWin.toFixed(2)
                    : ""
                }
              />
            </div>
          </div>
          <div className={CssClasses.colTicketActions}>
            <button className={CssClasses.actionBtn}>PRIKAŽI</button>
            <button className={CssClasses.actionBtn}>PONOVNO ISPIŠI</button>
            <button className={CssClasses.actionBtn}>STORNIRAJ</button>
          </div>
        </div>
      </div>
    );
  }

  txtTicketNumber_Change(e) {
    //alert(e.target.value);
    this.setState({ ticketNumber: e.target.value });
  }

  btnLoadData_Click() {
    SelectTicket(
      this.state.ticketNumber,
      this.selectTicket_Callback.bind(this)
    );
  }

  selectTicket_Callback(val) {
    console.log("IN CALLBACK... ", val);

    if (val) {
      //prilagodi sto ima
      val.TicketTypeFMT = val.IsSystem ? "Sistemski" : "Combo";
      val.IsEarlyPayoutFMT = val.IsEarlyPayoutFMT ? "DA" : "NE";
      val.StatusFMT =
        val.TicketStatusID === 1
          ? "Prihvaćen"
          : val.TicketStatusID === 4
          ? "Autoriziran"
          : val.TicketStatusID === 7
          ? "Dobitni"
          : val.TicketStatusID === 8
          ? "Gubitni"
          : val.TicketStatusID === 9
          ? "Isplaćen"
          : "Nepoznat [" + val.TicketStatusID + "]";
      this.setState({ currentTicket: val });
    }
  }

  datePicker_ValueChanged(id, date) {
    if (id === 1) {
      //start date
      this.setState({ startDate: date });
    } else {
      //end date
      this.setState({ endDate: date });
    }
  }
}

const mapStateToProps = state => {
  return {
    isAdminLoadingShown: state.rrNavigation.isAdminLoadingShown
  };
};

const mapDispatchToProps = dispatch => {
  return {
    changeAdminLoadingIndicator: isLoading =>
      dispatch(StoreActions.ChangeAdminLoadingIndicator(isLoading))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FindTicket);



// WEBPACK FOOTER //
// ./src/Containers/AdminScreens/FindTicket/FindTicket.js